import { Button, Form, message, Select, Upload, UploadFile, UploadProps } from "antd";
import fileDownload from "js-file-download";
import { useState, useEffect } from "react";
import { Dispatch, SetStateAction } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { useReactiveVar } from "@apollo/client";
import { localUploadBaseProps } from "../../../utils/localUploadRequest";
//import "./EALMBonusIncentive.scss";
import { fetchSalesContestData } from "./utils/fetchSalesContestData";
import Spinner from "../../../components/layout/spinner/Spinner";
import NoPermission from "../../../components/others/NoPermission";
import ContentTitle from "../../../components/ui/ContentTitle";
import { useGetUserProgramsByServiceQuery } from "../../../graphql/operations/get-user-program-by-service";
import { useUploadFileMutation } from "../../../graphql/operations/upload-file";
import { AfBlobPath } from "../../../graphql/operations/@types";
import {
  __currentUser__,
  __jwtToken__,
  __projectKey__,
} from "../../../graphql/policies";
import { ServiceTypes } from "../../../types/types";
import { apiCall } from "../../../utils/apiCall";
import requiredRule from "../../../utils/formRules/requiredRule";
import { renderAntDMessageConfig } from "../../../utils/renderAntDMessageConfig";
import { renderDecodedId } from "../../../utils/renderDecodedId";
interface SalesContestReportProps {
  setSelectedService: Dispatch<SetStateAction<ServiceTypes>>;
  setSelectSubItem: Dispatch<SetStateAction<string | undefined>>;
}
interface SalesContestDataType {
  contestID: string;
  contestName: string;
}

const SalesContestReport = ({
  setSelectedService,
  setSelectSubItem,
}: SalesContestReportProps) => {
  const [form] = Form.useForm();
  const [uploadFile] = useUploadFileMutation();
  const [salesContestData, setSalesContestData] = useState<SalesContestDataType[]>([]);
  const [isReportLoading, setIsReportLoading] = useState(false);
  const [isUploadLoading, setIsUploadLoading] = useState(false);

  const currentUser = useReactiveVar(__currentUser__);
  const jwtToken = useReactiveVar(__jwtToken__);
  const projectKey = useReactiveVar(__projectKey__);

  const { data: userPrograms, loading: userProgramsLoading } =
    useGetUserProgramsByServiceQuery({
      variables: {
        userId: parseInt(renderDecodedId(currentUser?.id)),
        serviceId: 5,
      },
    });

  const props: UploadProps = {
    ...localUploadBaseProps,

    maxCount: 1,
    beforeUpload: (file) => {
      const isXlsx = file.name.toLowerCase().endsWith('xlsx');

      if (!isXlsx) {
        message.error(renderAntDMessageConfig("Only upload xlsx file!"));
      }

      return isXlsx || Upload.LIST_IGNORE;
    }
  };

  const handleReportSubmit = () => {
    form.setFields([{ name: 'file', errors: [] }]);
    form
      .validateFields(['salesContest'])
      .then(async () => {
        setIsReportLoading(true);
        const { salesContest } = form.getFieldsValue();
        //const dateHeader = {
        //  headers: {
        //    Authorization: `Bearer ${jwtToken}`,
        //    "X-Project-Id": "AF",
        //    "X-Authorization-Provider": "Anonymous",
        //    "X-Project-Key": projectKey,
        //  }
        //};
        //const netDate = await apiCall({
        //  method: "GET",
        //  header: dateHeader,
        //  endPoint:
        //    process.env.REACT_APP_GET_SALES_CONTEST_NET_DATE +
        //    salesContest,
        //});
        //const fileName = `ContestSalesReport-${salesContest}-${netDate}`;
        const fileName = `ContestSalesReport-${salesContest}`;

        const header = {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            "X-Project-Id": "AF",
            "X-Authorization-Provider": "Anonymous",
            "X-Project-Key": projectKey,
          },
          responseType: "blob",
        };
        const data = await apiCall({
          method: "GET",
          header: header,
          endPoint:
            process.env.REACT_APP_GET_SALES_CONTEST_REPORT +
            fileName +
            "/" +
            salesContest,
        });
        
        fileDownload(data, `${fileName}.xlsx`);

        setIsReportLoading(false);
      })
      .catch((e) => console.log(e));
  };

  const handleUploadSubmit = () => {
    form
      .validateFields(['salesContest','file'])
      .then(async () => {
        setIsUploadLoading(true);
        const { salesContest, file } = form.getFieldsValue();
        if (file.length > 0) {
          const originalFile = file[0].originFileObj;
          const customFileName = `ContestSalesReport-${salesContest}.xlsx`;
          const renamedFile = new File([originalFile], customFileName, {
            type: originalFile.type,
          });

          uploadFile({
            variables: {
              blobs: [
                {
                  file: renamedFile,
                  path: AfBlobPath.SalesContestReport,
                },
              ],
            },
          }).catch((e) => console.log(e));

          const header = {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
              "X-Project-Id": "AF",
              "X-Authorization-Provider": "Anonymous",
              "X-Project-Key": projectKey,
            },
          };
          await apiCall({
            method: "GET",
            header: header,
            endPoint:
              process.env.REACT_APP_UPDATE_SALES_CONTEST_URL +
              salesContest +
              "/" +
              customFileName,
          });
        }

        message.success("Successfully");
        setIsUploadLoading(false);
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    setSelectedService(ServiceTypes.SALES_188);
    setSelectSubItem("Sales Contest Report");
    fetchSalesContestData(jwtToken, projectKey)
      .then((data) => {
        setSalesContestData(data);
      });
  }, []);

  if (userProgramsLoading) {
    return <Spinner />;
  }

  if (
    userPrograms &&
    !userPrograms.wf_adminFirst_afUserProgram?.edges?.find(
      (item) => item.node.afProgram?.programName === "Sales Contest Report"
    )
  ) {
    return <NoPermission />;
  }

  return (
    <div id="ealmBonusIncentiveWrapper">
      <ContentTitle title="Sales Contest Report" />
      <div className="table-container">
        <Form form={form} name="ealm-bonus-form" className="form">
          <div className="flex">
            <Form.Item
              name="salesContest"
              rules={[requiredRule]}
              label="業務競賽名稱"
              className="item"
            >
              <Select
                options={salesContestData?.map((item) => ({
                  label: item.contestName,
                  value: item.contestID,
                }))}
              />
            </Form.Item>
            <Button
              type="primary"
              className="ms-5"
              onClick={handleReportSubmit}
              loading={isReportLoading}
            >
              產生Excel報表
            </Button>
          </div>
          <div className="flex">
            <Form.Item
              name="file"
              rules={[requiredRule]}
              valuePropName="fileList"
              getValueFromEvent={(e) => e.fileList}
            >
              <Upload
                {...props}
              >
                <Button icon={<UploadOutlined />} style={{ width: 200 }} >
                  上傳Excel
                </Button>

              </Upload>
            </Form.Item>
            <Button
              type="primary"
              className="ms-5"
              onClick={handleUploadSubmit}
              loading={isUploadLoading}
            >
              上傳競賽報表
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default SalesContestReport;
